import {NgModule, Injector} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HotelCubesComponent} from './hotel-cubes/hotel-cubes.component';
import {DirectivesModule} from '../../directives-module/directives.module';
import {createCustomElement} from '@angular/elements';
import {Routes, RouterModule} from '@angular/router';

const routes: Routes = [];

@NgModule({
  declarations: [HotelCubesComponent],
  imports: [CommonModule, DirectivesModule, RouterModule.forChild(routes)],
  entryComponents: [HotelCubesComponent]
})
export class HotelCubesModule {
  constructor(injector: Injector) {
    if (customElements.get('app-hotel-cubes') == null) {
      const el = createCustomElement(HotelCubesComponent, { injector });
      customElements.define('app-hotel-cubes', el);
    }
  }
}
